import { useChannelTalk } from '@repo/channel-talk';
import { Button, Description } from '@zenterprise-inc/ui';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link';

const WaitContent = () => {
  const { openChannelTalk } = useChannelTalk();

  return (
    <div className="flex h-screen flex-col items-center justify-center pb-[108px]">
      <Description>
        <Description.Guide
          imgChild={<img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/icons/icg_document-mag_md.svg`} className={'w-20 h-20'} alt={'document-mag'} />}
          subTitle={'아직 국세청에서\n신고서 검토 중이에요'}
          description={'신고 후 2개월 이상 소요될 수 있어요.\n환급까지 조금만 더 기다려주세요.'}
        />
      </Description>
      <div className={'full-width text-14 absolute bottom-0 pb-12 pl-7 pr-7 text-gray-700'}>
        <span className={'mr-2.5'}>궁금하신 점이 있으시면 문의해주세요.</span>
        <Button.Box
          state={'secondary'}
          size={'small'}
          onClick={() => {
            openChannelTalk(SUPPORT_BOT_LINK.환급결정확인);
          }}
        >
          문의하기
        </Button.Box>
      </div>
    </div>
  );
};

export default WaitContent;
